function initCategoryFocus() {
  const hud = document.querySelector('.category-focus__hud');
  if (!hud) return;

  const container = hud.parentElement;
  container.style.position = 'relative';

  function update() {
    const rect = container.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (rect.top > 0) {
      hud.style.position = 'absolute';
      hud.style.top = '0';
      hud.style.left = '0';
      hud.style.width = '100%';
    } else if (rect.bottom < viewportHeight) {
      hud.style.position = 'absolute';
      hud.style.top = `${container.offsetHeight - viewportHeight}px`;
      hud.style.left = '0';
      hud.style.width = '100%';
    } else {
      hud.style.position = 'fixed';
      hud.style.top = '0';
      hud.style.left = `${rect.left}px`;
      hud.style.width = `${rect.width}px`;
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

function initCategoryRowFocus() {
  const rows = document.querySelectorAll('.category-focus__row');
  if (!rows.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-focused', entry.isIntersecting);
      });
    },
    { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
  );

  rows.forEach((row) => observer.observe(row));
}

document.addEventListener('DOMContentLoaded', initCategoryFocus);
document.addEventListener('DOMContentLoaded', initCategoryRowFocus);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCategoryFocus);
  document.addEventListener('shopify:section:load', initCategoryRowFocus);
}
